var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5979 22.7998H20.8779",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.62,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0815 7.80037L19.8829 7.00117C20.1985 6.68567 20.4488 6.31111 20.6196 5.89887C20.7904 5.48663 20.8784 5.04478 20.8784 4.59855C20.8785 4.15232 20.7906 3.71045 20.6199 3.29817C20.4492 2.88589 20.1989 2.51128 19.8834 2.19571C19.5679 1.88014 19.1934 1.62981 18.7811 1.459C18.3689 1.28819 17.927 1.20025 17.4808 1.2002C17.0346 1.20015 16.5927 1.28799 16.1804 1.4587C15.7682 1.62942 15.3935 1.87967 15.078 2.19517L14.2766 2.99653C14.2766 2.99653 14.3771 4.69861 15.8783 6.19981C17.3795 7.70101 19.0815 7.80145 19.0815 7.80145L11.7192 15.1638C11.2202 15.6628 10.9718 15.9112 10.6964 16.1261C10.3717 16.3795 10.0229 16.5952 9.64989 16.773C9.33561 16.9231 9.00081 17.0344 8.33229 17.2569L5.49621 18.2029M14.2766 2.99545L6.91425 10.3589C6.41529 10.8578 6.16581 11.1062 5.95197 11.3816C5.69865 11.7057 5.48171 12.0567 5.30505 12.4282C5.15493 12.7424 5.04369 13.0772 4.82013 13.7458L3.87513 16.5819M3.87513 16.5819L3.64509 17.2741C3.59117 17.4355 3.58328 17.6088 3.62233 17.7744C3.66138 17.9401 3.7458 18.0916 3.86614 18.2119C3.98648 18.3323 4.13797 18.4167 4.30362 18.4557C4.46926 18.4948 4.64251 18.4869 4.80393 18.433L5.49621 18.2029M3.87513 16.5819L5.49621 18.2029",
    stroke: "#1A4338",
    style: (_ref3 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.62
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.043ccb8f.svg";
export { ForwardRef as ReactComponent };